<div class="order-detail">
    <div  *ngIf="isLoading" class="wb-loader"> <span class="loading-animation"></span></div>
    <div class="row text-center wb-summary-title">
      <h1>My Order Details</h1>
    </div>
    <div class="inner-container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 show-details">
        <a class="accordion-toggle collapsed" href="#order-1" data-toggle="collapse" data-parent="#accordion">
          Do You Want to Edit this Order?
          <span class="dt-open"></span>
          <span class="dt-close"></span>
        </a>
        <div id="order-1" class="edit-order-content collapse">
          <p>To edit, we'll need to cancel your order in our system. You'll return to the order summary where you can make changes
            to your order and payment method.</p>
          <p>You may also have to choose a new pickup time. Don't worry, you won't be charged twice. </p>
          <button (click)="cancelOrder()" class="btn wb-btn-default mg-top-12">Cancel Order and Edit</button>
        </div>

      </div>
    </div>
    <div class="wab-cat-detail" *ngFor="let childRecipe of childRecipeList">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 text-left">
            <h6 *ngIf="childRecipe?.customName">{{childRecipe.customName}}</h6>
            <h4>{{ getRecipeName(childRecipe?childRecipe.name:'',childRecipe?childRecipe.subTitle:'')}} </h4>
            <p>{{ getRecipeSubtitle(childRecipe?childRecipe.name:'',childRecipe?childRecipe.subTitle:'')}}</p>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5 text-right">
          <h4>
            <i class="fa fa-gift" aria-hidden="true" *ngIf="isOfferItem(childRecipe)"></i>
            <i class="fa fa-trophy" aria-hidden="true" *ngIf="isRewardItem(childRecipe)"></i>
            ${{childRecipe.totalPrice | number: '1.2-2' }}
          </h4>
          <h4 class="cal-detail">{{childRecipe.totalCalories}} Cal
          </h4>
        </div>
      </div>
      <div class="row includes-sides">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <b>Includes:
            <span> {{childRecipe.whatsOnIt}}</span>
          </b>
          <b *ngIf="childRecipe.comesWith">Side & Drinks:
            <span>{{childRecipe.comesWith}} </span>
          </b>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
          <p><b>Quantity: <span>{{childRecipe.quantity}}</span></b></p>
        </div>
      </div>
    </div>
    <div class="row">
      <hr/>
    </div><!-- we can avoid using this because for only hr creating the div element.try to use border instead -- jegan-->

    <div class="totals-taxes-wrapper row">
      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 text-right">
        <p *ngFor="let item of orderDetails?.orderTotalLineItem">{{item?.description}}<sup *ngIf="!isTaxIncluded && item.itemType == OrderLineItemType.tax">*</sup></p>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-right">
          <p *ngFor="let item of orderDetails?.orderTotalLineItem">{{item?.formattedAmount}}</p>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
        <span *ngIf="!isTaxIncluded">*Tax is approximate until sale is finalized.</span>
        <span *ngIf="isTaxIncluded">Tax Included In Total</span>

      </div>
    </div>
    <div class="row">
      <hr/>
    </div><!-- we can avoid using this because for only hr creating the div element.try to use border instead -- jegan-->
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <p class="hint-text">2,000 Calories a day is used for general nutrition advice, but calorie needs vary.</p>
    </div>
  </div>
</div>

